import { array, func, node, oneOf, oneOfType, shape, string } from "prop-types";

import classes from "./section.scss";

const CheckoutTourismDomesticSection = ({
  className,
  children,
  title,
  subtitle,
}) => {
  return children || title || subtitle ? (
    <section className={className || classes.root}>
      {title ? <h2 className={classes.title}>{title}</h2> : null}
      {subtitle ? (
        <strong className={classes.subtitle}>{subtitle}</strong>
      ) : null}
      {children}
    </section>
  ) : null;
};

CheckoutTourismDomesticSection.propTypes = {
  className: string,
  children: oneOfType([node, string, array, func, shape({}), oneOf([null])])
    .isRequired,
  title: string,
  subtitle: string,
};

CheckoutTourismDomesticSection.defaultProps = {
  className: "",
  title: "",
  subtitle: "",
};

export default CheckoutTourismDomesticSection;
